import { c as _c } from "react/compiler-runtime";
import { useId } from "react";
import { fillVariants } from "../../../styles";
export const SolanaLogoCircle = t0 => {
  const $ = _c(28);
  let className;
  let rest;
  let square;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      square,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = square;
    $[4] = t1;
  } else {
    className = $[1];
    rest = $[2];
    square = $[3];
    t1 = $[4];
  }
  const size = t1 === undefined ? 24 : t1;
  const gradientId = useId();
  let t2;
  if ($[5] !== size) {
    t2 = {
      width: size,
      height: size
    };
    $[5] = size;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <stop offset="8%" stopColor="#9945FF" />;
    t4 = <stop offset="30%" stopColor="#8752F3" />;
    t5 = <stop offset="50%" stopColor="#5497D5" />;
    t6 = <stop offset="60%" stopColor="#43B4CA" />;
    t7 = <stop offset="72%" stopColor="#28E0B9" />;
    t8 = <stop offset="97%" stopColor="#19FB9B" />;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
    t8 = $[12];
  }
  let t9;
  if ($[13] !== gradientId) {
    t9 = <defs><linearGradient id={gradientId} x1="8.441%" x2="88.112%" y1="89.766%" y2="9.441%">{t3}{t4}{t5}{t6}{t7}{t8}</linearGradient></defs>;
    $[13] = gradientId;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const t10 = square ? 0 : 12;
  let t11;
  if ($[15] !== t10) {
    t11 = <rect fill="#121212" height={24} rx={t10} width={24} />;
    $[15] = t10;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  const t12 = `url(#${gradientId})`;
  let t13;
  if ($[17] !== t12) {
    t13 = <path d="m13.779 9.514-2.287 2.389a.531.531 0 0 1-.388.164H.265a.27.27 0 0 1-.145-.042.252.252 0 0 1-.049-.393L2.36 9.244a.531.531 0 0 1 .388-.165h10.838a.27.27 0 0 1 .145.043.253.253 0 0 1 .049.393Zm-2.287-4.81a.531.531 0 0 0-.388-.164H.265a.27.27 0 0 0-.145.042.253.253 0 0 0-.049.393L2.36 7.363a.531.531 0 0 0 .388.165h10.838a.27.27 0 0 0 .145-.043.253.253 0 0 0 .049-.393l-2.287-2.388ZM.265 2.988h10.839a.544.544 0 0 0 .388-.164L13.78.435a.256.256 0 0 0 .049-.28.261.261 0 0 0-.098-.113.27.27 0 0 0-.145-.042H2.747a.543.543 0 0 0-.388.164L.072 2.554a.256.256 0 0 0-.05.278.26.26 0 0 0 .098.114.27.27 0 0 0 .145.042Z" fill={t12} transform="translate(5.075 5.965)" />;
    $[17] = t12;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t11 || $[20] !== t13) {
    t14 = <g fill="none" fillRule="nonzero">{t11}{t13}</g>;
    $[19] = t11;
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== className || $[23] !== rest || $[24] !== t14 || $[25] !== t2 || $[26] !== t9) {
    t15 = <svg className={className} style={t2} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t9}{t14}</svg>;
    $[22] = className;
    $[23] = rest;
    $[24] = t14;
    $[25] = t2;
    $[26] = t9;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  return t15;
};
export const SolanaLogoCircleMonochrome = t0 => {
  const $ = _c(18);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      fill: t2,
      fillAttribute: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const size = t1 === undefined ? 24 : t1;
  const fill = t2 === undefined ? "current" : t2;
  const fillAttribute = t3 === undefined ? "currentColor" : t3;
  let t4;
  if ($[6] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fill) {
    t5 = fillVariants({
      fill
    });
    $[8] = fill;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fillAttribute || $[11] !== t5) {
    t6 = <path className={t5} d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0Zm6.66 15.044H7.822a.543.543 0 0 0-.388.165l-2.288 2.388a.256.256 0 0 0-.049.28.26.26 0 0 0 .098.113.27.27 0 0 0 .145.042H16.18a.543.543 0 0 0 .388-.164l2.287-2.389a.256.256 0 0 0 .049-.28.261.261 0 0 0-.098-.112.27.27 0 0 0-.145-.043Zm-2.481-4.54H5.34a.27.27 0 0 0-.145.043.253.253 0 0 0-.049.393l2.288 2.388a.531.531 0 0 0 .388.165H18.66a.27.27 0 0 0 .145-.043.253.253 0 0 0 .049-.393l-2.287-2.388a.531.531 0 0 0-.388-.164Zm2.48-4.539H7.823a.543.543 0 0 0-.388.164L5.147 8.52a.256.256 0 0 0-.05.278.26.26 0 0 0 .098.114.27.27 0 0 0 .145.042H16.18a.544.544 0 0 0 .388-.164L18.854 6.4a.256.256 0 0 0 .049-.28.261.261 0 0 0-.098-.113.27.27 0 0 0-.145-.042Z" fill={fillAttribute} fillRule="nonzero" />;
    $[10] = fillAttribute;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== className || $[14] !== rest || $[15] !== t4 || $[16] !== t6) {
    t7 = <svg className={className} style={t4} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[13] = className;
    $[14] = rest;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};